import { render, staticRenderFns } from "./IFormItem.vue?vue&type=template&id=54a971af&scoped=true&"
import script from "./IFormItem.vue?vue&type=script&lang=js&"
export * from "./IFormItem.vue?vue&type=script&lang=js&"
import style0 from "./IFormItem.vue?vue&type=style&index=0&id=54a971af&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a971af",
  null
  
)

export default component.exports